module.exports = __webpack_public_path__ + "static/media/lightbulb.02875f82.svg";